import { stringifyQs } from "@saleor/utils/urls";

export const orderConfirmUrl = "/order-confirm";

import { Pagination, Sort } from "@saleor/types";

export enum OrderConfirmListSortField {
  soNo = "soNo"
}

export type OrderConfirmUrlSort = Sort<OrderConfirmListSortField>;
export type OrderConfirmUrlQueryParams = Pagination & OrderConfirmUrlSort;

export const OrderConfirmListUrl = (params?: OrderConfirmUrlQueryParams) =>
  orderConfirmUrl + "?" + stringifyQs(params);
